<div class="body-face-capture">
  <div class="media-face-capture">
    <div *ngIf="!capturedImage" class="video-container">
      <video #videoElement autoplay muted playsinline></video>
      <div class="oval-border"></div>
    </div>
    <img *ngIf="capturedImage" [src]="capturedImage" alt="Captured Face" />
  </div>
  <p class="status-face-capture">{{ detectionStatus }}</p>
</div>